/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var splitMarks = /(^[\s *]+)|([\s ：:~-]+$)|([（(]\d+[)）])/gm;
var getInnerText = function (target) { return target.innerText || target.title || target.defaultValue; };
function getText(targetOrTargets) {
    var targets = Array.isArray(targetOrTargets) ? targetOrTargets : [targetOrTargets];
    var l = targets.length;
    for (var i = 0; i < l; i++) {
        var target = targets[i];
        var rawText = getInnerText(target);
        if (rawText) {
            var text = getInnerText(removeBadge(target));
            if (!text) {
                continue;
            }
            return text.replace(splitMarks, '');
        }
    }
    return '';
}
/**
  * 克隆并去除内部的 badge（如有）
  * @param {*}target 目标结点
  */
function removeBadge(target) {
    var hasBadge = !!target.querySelector('.badge');
    if (hasBadge) {
        var clonedTarget = target.cloneNode(true);
        var badges = Array.prototype.slice.apply(clonedTarget.querySelectorAll('.badge')) || [];
        badges.forEach(function (e) { var _a; return (_a = e.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(e); });
        return clonedTarget;
    }
    return target;
}
var clickableRole = ['button', 'checkbox', 'link', 'menuitem', 'radio', 'tab', 'combobox', 'search'];
function getFeature(target) {
    var role = target.getAttribute('role');
    if (role && clickableRole.indexOf(role)) {
        return role;
    }
    return 'feature';
}

/**
* 生成目标结点的 pathInfo
*/
function generatePathInfo(target) {
    var reversedDOMArray = [];
    var reversedXPathArray = [];
    var reversedTagNameArray = [];
    var iterator = target;
    var stopGenerateXpath = false;
    var _loop_1 = function () {
        //当 iterator 为 form 的时候。tagName 可能获取到 HTMLElement
        // <form><input id="tagName" /></form>
        // form.tagName === input
        var tn = iterator.tagName;
        var tagName = typeof tn === 'string' ? tn.toLocaleLowerCase() : iterator instanceof HTMLFormElement ? 'form' : 'unknown';
        reversedTagNameArray.push(tagName);
        reversedDOMArray.push(iterator);
        if (!stopGenerateXpath) {
            var id = iterator.id;
            if (id && iterator !== document.body && iterator !== document.documentElement) {
                reversedXPathArray.push("/*[@id=\"".concat(id, "\"]"));
                stopGenerateXpath = true;
            }
            if (iterator.parentElement) {
                var children = Array.prototype.slice.apply(iterator.parentElement.children).filter(function (e) {
                    return e.tagName.toLocaleLowerCase() === tagName;
                });
                if (children.length > 1) {
                    tagName = "".concat(tagName, "[").concat(children.indexOf(iterator) + 1, "]");
                }
            }
            if (!stopGenerateXpath) {
                reversedXPathArray.push(tagName);
            }
        }
        iterator = iterator.parentElement;
    };
    while (iterator) {
        _loop_1();
    }
    return {
        reversedXPathArray: reversedXPathArray,
        reversedDOMArray: reversedDOMArray,
        xpath: getXPathFromReversedXPathArray(reversedXPathArray),
        reversedTagNameArray: reversedTagNameArray,
    };
}
function getXPathFromReversedXPathArray(reversedXPathArray) {
    var array = [].concat(reversedXPathArray);
    return "/".concat(array.reverse().join('/'));
}
function generatePathInfoWithDescendant(target, _a) {
    var reversedDOMArray = _a.reversedDOMArray, reversedXPathArray = _a.reversedXPathArray, reversedTagNameArray = _a.reversedTagNameArray;
    var index = reversedDOMArray.indexOf(target);
    if (index !== -1) {
        var end = index + 1;
        var xpathArray = reversedXPathArray.slice(0, end);
        return {
            reversedDOMArray: reversedDOMArray.slice(0, end),
            reversedTagNameArray: reversedTagNameArray.slice(0, end),
            reversedXPathArray: xpathArray,
            xpath: getXPathFromReversedXPathArray(xpathArray),
        };
    }
    else {
        return generatePathInfo(target);
    }
}

var isDebug = location.href.indexOf('et_debug') > -1;
var filterUndefined = function (o) {
    if (!o) {
        return o;
    }
    var result = {};
    Object.keys(o).forEach(function (k) {
        var v = o[k];
        if (v !== undefined) {
            result[k] = o[k];
        }
    });
    return result;
};

var registry = [];
var ruleList = [];
var addPlugin = function (plugin, config, lowPriority) {
    removePlugin(plugin.name, true);
    var _c = filterUndefined(config);
    var pluginLoaded = __assign(__assign({}, plugin), { config: _c });
    if (isDebug) {
        console.log("[ETracker:autolog] 注册插件", pluginLoaded);
    }
    registry[lowPriority ? 'unshift' : 'push'](pluginLoaded);
    rebuildRuleList();
};
var removePlugin = function (pluginName, doNotRebuild) {
    if (!pluginName) {
        return;
    }
    if (isDebug) {
        console.log("[ETracker:autolog] 移除插件", pluginName);
    }
    if (pluginName === true) {
        registry = [];
    }
    else {
        registry = registry.filter(function (p) { return p.name !== pluginName; });
    }
    !doNotRebuild && rebuildRuleList();
};
var rebuildRuleList = function () {
    var prioritized = [];
    var normal = [];
    registry.forEach(function (p) {
        if (p.prioritizedRules) {
            prioritized = __spreadArray(__spreadArray([], prioritized, true), p.prioritizedRules, true).map(function (r) {
                var rule = __assign(__assign({}, r), { plugin: p });
                return rule;
            });
        }
        if (p.rules) {
            normal = __spreadArray(__spreadArray([], normal, true), p.rules, true).map(function (r) {
                var rule = __assign(__assign({}, r), { plugin: p });
                return rule;
            });
        }
    });
    ruleList = __spreadArray(__spreadArray([], prioritized, true), normal, true);
};
var generateRuntimeInfo = function (e, prevInfo) {
    var info = !prevInfo ? generatePathInfo(e) : generatePathInfoWithDescendant(e, prevInfo);
    return __assign(__assign({}, info), { tagName: e.tagName.toLowerCase() });
};
var runThroughRules = function (source, isRestarted) {
    if (isDebug) {
        console.log("[ETracker:autolog] 点击事件目标！", source);
    }
    var l = ruleList.length;
    var result = {
        feature: '',
        text: '',
        xpath: '',
        container: '',
        target: source,
    };
    var runtime = {
        info: generateRuntimeInfo(source),
        utils: {
            getFeature: getFeature,
            getText: getText,
        },
    };
    var params = __assign({ source: source }, runtime);
    for (var i = 0; i < l; i++) {
        var rule = ruleList[i];
        try {
            var selector = rule.selector, action = rule.action, plugin = rule.plugin;
            params.config = __assign(__assign({}, plugin.defaultConfig), plugin.config);
            var target = selector(params); //绕过了类型系统。小心改动
            if (target) {
                if (isDebug) {
                    console.log('[ETracker:autolog] 命中规则', rule);
                }
                params.target = target;
                result.target = target;
                if (target !== source) {
                    // 如果通过 selector 重定向了目标。需要重新计算 info
                    params.info = generateRuntimeInfo(target);
                }
                var pluginResult = typeof action === 'function' ? action(params) : action;
                if (!pluginResult) {
                    result.feature = result.feature || getFeature(target);
                    result.text = result.text || getText(target);
                    result.xpath = result.xpath || params.info.xpath;
                }
                else {
                    var __continue = pluginResult.__continue, __restart = pluginResult.__restart, rest = __rest(pluginResult, ["__continue", "__restart"]);
                    if (pluginResult.__restart) {
                        if (isRestarted) {
                            console.error('[ETracker:autolog] 己经重新执行过规则。请检查规则逻辑');
                            console.error(rule);
                        }
                        else {
                            return runThroughRules(target, true);
                        }
                    }
                    result.feature = result.feature || rest.feature || getFeature(target);
                    result.text = result.text || rest.text || getText(target);
                    result.xpath = result.xpath || rest.xpath || params.info.xpath;
                    result.container = result.container || rest.container || '';
                    result.extra = rest.extra ? __assign(__assign({}, result.extra), filterUndefined(rest.extra)) : result.extra;
                    if (pluginResult.__continue) {
                        continue;
                    }
                }
                break;
            }
        }
        catch (e) {
            console.error('[ETracker:autolog〕规则执行出错', rule);
            console.error(e);
        }
    }
    return result;
};
var run = function (source) {
    var _a = runThroughRules(source), target = _a.target, extra = _a.extra, result = __rest(_a, ["target", "extra"]);
    if (isDebug) {
        console.log("[ETracker:autolog] 采集结果", target, result);
    }
    var isValid = !!result.feature;
    if (isValid) {
        var r = __assign(__assign(__assign({}, filterUndefined(extra)), filterUndefined(result)), { className: target.getAttribute('class') || '', selector: '', logtype: 'CLK' });
        if (isDebug) {
            console.log("[ETracker:autolog] 有效结果", r);
        }
        return r;
    }
};

var getNow = function () { return new Date().valueOf(); };
/**
* 探测是否支持触屏
*/
var isTouchSupported = window && 'ontouchstart' in window;
var registeredListeners = {};
var startListen = function (handler) {
    stopListen();
    if (!isTouchSupported) {
        document.addEventListener('mousedown', handler);
        registeredListeners.mousedown = handler;
    }
    else {
        var start_1;
        var touchStartHandler = function (e) {
            var touches = e.touches, changedTouches = e.changedTouches;
            if (touches.length !== 1 || changedTouches.length !== 1) {
                return;
            }
            var _a = changedTouches[0], pageX = _a.pageX, pageY = _a.pageY;
            start_1 = { time: getNow(), pageX: pageX, pageY: pageY };
        };
        var touchEndHandler = function (e) {
            var changedTouches = e.changedTouches;
            if (changedTouches.length !== 1 || !start_1) {
                return;
            }
            var _a = changedTouches[0], pageX = _a.pageX, pageY = _a.pageY;
            var duration = getNow() - start_1.time;
            var dx = (start_1.pageX - pageX) | 0;
            var dy = (start_1.pageY - pageY) | 0;
            var displacementSquare = dx * dx + dy * dy;
            // TODO: changelog 2.0
            // 长按判断缩短至 500ms
            // 偏移量判断缩小至 6px
            if (duration < 500 && displacementSquare < 36) {
                handler(e);
            }
            start_1 = undefined;
        };
        document.addEventListener('touchstart', touchStartHandler);
        document.addEventListener('touchend', touchEndHandler);
        registeredListeners.touchstart = touchStartHandler;
        registeredListeners.touchend = touchEndHandler;
    }
};
var stopListen = function () {
    Object.keys(registeredListeners).map(function (key) {
        var k = key;
        var l = registeredListeners[k];
        if (l) {
            document.removeEventListener(k, l);
        }
    });
};

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var decode = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var parse;

parse = decode;

var containerRule = {
    selector: function (_a) {
        var info = _a.info, containerProps = _a.config.containerProps;
        if (!containerProps || containerProps.length === 0) {
            return;
        }
        var range = info.reversedDOMArray;
        var target = range.filter(function (e) {
            return containerProps.map(function (name) { return e.getAttribute(name); }).filter(Boolean)[0];
        })[0];
        return target;
    },
    action: function (_a) {
        var target = _a.target, config = _a.config;
        var container = config.containerProps.map(function (name) {
            return target.getAttribute(name);
        }).filter(Boolean)[0] || '';
        return {
            container: container,
            __continue: true,
        };
    },
};
var dataAutoLogRule = {
    selector: function (_a) {
        var info = _a.info, config = _a.config;
        var range = info.reversedDOMArray.slice(0, 5);
        var target = range.filter(function (e) {
            return config.autologProps.map(function (name) { return e.getAttribute(name); }).filter(Boolean)[0];
        })[0];
        return target;
    },
    action: function (_a) {
        var source = _a.source, target = _a.target, config = _a.config;
        if (source === target) {
            var _b = config.autologProps.map(function (name) {
                var value = target.getAttribute(name);
                if (value) {
                    return config.autologPropsHandler(value, name);
                }
            }).filter(Boolean)[0] || {}, feature = _b.feature, text = _b.text, xpath = _b.xpath, extra = _b.extra;
            return {
                feature: feature,
                text: text,
                xpath: xpath,
                extra: extra && Object.keys(extra).length > 0 ? extra : undefined,
                __continue: true,
            };
        }
        return { __restart: true };
    },
};
var labelElementRule = {
    selector: function (_a) {
        var info = _a.info;
        var index = info.reversedTagNameArray.indexOf('label');
        if (index !== -1) {
            return info.reversedDOMArray[index];
        }
    },
    action: function (_a) {
        var target = _a.target;
        var firstInput = target.getElementsByTagName('input')[0];
        if (firstInput) {
            var inputType = firstInput.type;
            if (inputType === 'checkbox' || inputType === 'radio') {
                return { feature: inputType };
            }
        }
    },
};
var linkElementRule = {
    selector: function (_a) {
        var info = _a.info, source = _a.source;
        if (info.tagName === 'area') {
            return source;
        }
        var index = info.reversedTagNameArray.indexOf('a');
        if (index !== -1) {
            return info.reversedDOMArray[index];
        }
    },
    action: { feature: 'link' },
};
var buttonElementRule = {
    selector: function (_a) {
        var info = _a.info;
        var index = info.reversedTagNameArray.indexOf('button');
        if (index !== -1) {
            return info.reversedDOMArray[index];
        }
    },
    action: { feature: 'button' },
};
var svgElementRule = {
    selector: function (_a) {
        var info = _a.info;
        var index = info.reversedTagNameArray.indexOf('svg');
        if (index !== -1) {
            return info.reversedDOMArray[index];
        }
    },
    action: function (_a) {
        var target = _a.target;
        if (getComputedStyle(target).cursor === 'pointer') {
            return { feature: 'icon-button' };
        }
    },
};
var imageElementRule = {
    selector: function (_a) {
        var info = _a.info, source = _a.source;
        var tagName = info.tagName;
        if (tagName === 'img') {
            return source;
        }
    },
    action: function (_a) {
        var target = _a.target;
        var text = target.alt;
        var feature = 'image';
        if (getComputedStyle(target).cursor === 'pointer') {
            feature = 'icon-button';
        }
        return { feature: feature, text: text };
    },
};
var inputTextareaElementRule = {
    selector: function (_a) {
        var info = _a.info, source = _a.source;
        var tagName = info.tagName;
        if (tagName === 'input' || tagName === 'textarea') {
            return source;
        }
    },
    action: function (_a) {
        var target = _a.target, info = _a.info;
        var type = target.type;
        var feature = '';
        if (type === 'submit') {
            feature = 'button';
        }
        else {
            feature = type || info.tagName;
        }
        return { feature: feature };
    },
};
/**
  * 目标含有 cursor： pointer 样式
  */
var cursorPointerRule = {
    selector: function (_a) {
        var source = _a.source;
        if (getComputedStyle(source).cursor === 'pointer') {
            return source;
        }
    },
    action: { feature: 'clickable' },
};
var plugin = {
    name: 'builtin',
    prioritizedRules: [containerRule, dataAutoLogRule],
    rules: [
        labelElementRule,
        linkElementRule,
        buttonElementRule,
        svgElementRule,
        imageElementRule,
        inputTextareaElementRule,
        cursorPointerRule,
    ],
    defaultConfig: {
        containerProps: ['data-autolog-container'],
        autologProps: ['data-autolog'],
        autologPropsHandler: function (value) {
            console.log('afei autologPropsHandler', value);
            var _a = parse(value), feature = _a.feature, text = _a.text, xpath = _a.xpath, extra = __rest(_a, ["feature", "text", "xpath"]);
            return { feature: feature, text: text, xpath: xpath, extra: extra };
        },
    },
};

function ETrackerPluginAutolog(etracker) {
    var config = etracker.getConfig('plugin_autolog') || {};
    addPlugin(plugin, {
        autologProps: config.autologProps,
        autologPropsHandler: config.autologPropsHandler,
        containerProps: config.containerProps,
    });
    var start = function () {
        startListen(function (e) {
            if (e.target && e.target instanceof Element) {
                var result = run(e.target);
                if (result) {
                    etracker.log('autolog', {
                        p1: result.feature,
                        p2: result.text,
                        p3: result.xpath,
                        p4: result.selector,
                        p5: result.logtype,
                        p6: result.className,
                        p7: result.container
                    });
                }
            }
        });
    };
    var stop = function () {
        stopListen();
    };
    if (config.autoLoad !== false) {
        start();
    }
    return { addPlugin: addPlugin, removePlugin: removePlugin, builtinPlugin: plugin, start: start, stop: stop };
}

export { ETrackerPluginAutolog as default };
